import React from 'react';
import Home from './components/Home';
import {Route, Routes} from 'react-router-dom';
import ProductDetails from './components/ProductDetails';
import ProductList from './components/ProductList';
import AddProduct from './components/AddProduct';
import Download from './components/Download';
import Connect from './components/connect';
import MessageList from './components/MessageList';
function App() {
  return (
    <div className="App">
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/Home" element={<Home />} />
        <Route exact path="/add_product" element={<AddProduct />} />
        <Route exact path="/product_details" element={<ProductDetails />} />
        <Route exact path="/product_list" element={<ProductList />} />
        <Route exact path="/download" element={<Download />} />
        <Route exact path="/connect" element={<Connect />} />
        <Route exact path="/message_list" element={<MessageList />} />
      </Routes>
    </div>
  );
}

export default App;
